export default "__VITE_ASSET__DXIVlk6Q__ 288w, __VITE_ASSET__NHkz8y3e__ 432w, __VITE_ASSET__ImkusbXn__ 576w";